import { render, staticRenderFns } from "./advConfigList.vue?vue&type=template&id=520f7f5a&scoped=true"
import script from "./advConfigList.vue?vue&type=script&lang=js"
export * from "./advConfigList.vue?vue&type=script&lang=js"
import style0 from "./advConfigList.vue?vue&type=style&index=0&id=520f7f5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f7f5a",
  null
  
)

export default component.exports